import trackAnalytics, {ampli} from '@gaia/utils/gaia/trackAnalytics';
import getWebGLRendererInfo from '@gaia/utils/getWebGLRendererInfo';
import {isMobilePlatform} from '@gaia/utils/queryNavigator';
import once from 'lodash/once';

export const sendGLNotSupportedEvent = once(function sendGLNotSupportedEvent() {
    trackAnalytics('Mapbox GL Not Supported', {
        ...getWebGLRendererInfo(),
        category: 'map2',
    });
});

export function sendToggleMapOverlayEvent(type: Grid) {
    if (type === 'none') return;
    ampli.toggleMapOverlay({
        category: 'map2',
        isOn: true,
        type,
    });
}

export const sendViewedMainMapEvent = once(function sendViewedMainMapEvent() {
    trackAnalytics('Viewed Main Map', {
        url: window.location.href,
        path: 'map',
        isMobile: isMobilePlatform(),
    });
});
